import React from "react";
import styles from "./postShift.module.css";

interface ShiftDetail {
    label: string;
    value: string | number | undefined;
}

interface ShiftDetailsDisplayProps {
    details: ShiftDetail[];
}

export const ShiftDetailsDisplay: React.FC<ShiftDetailsDisplayProps> = ({ details }) => (
    <div className={styles.confirmGrid}>
        {details.map((detail) => 
            detail.value === undefined ? null : (
                <div key={detail.label} className={styles.confirmSection}>
                    <p className={styles.confirmLabel}>{detail.label}</p>
                    <p className={styles.confirmValue}>{detail.value}</p>
                </div>
            )
        )}
    </div>
);